import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  SVGIcon,
} from '@pearsontechnology/aero-components';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectWorkspacesList } from 'Workspace/Admin/store/selectors';
import {
  commandWorkspaceProjectList,
} from 'containers/ConnectionManager/actions';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import enhanceWithServices from 'hocs/enhanceWithServices';
import Modal, { ModalContent, ModalActions } from 'components/Modal';
import workspaceService from 'services/WorkspaceService';

import {
  WorkspaceList,
  WorkspaceListItem,
} from './styles';
import messages from './messages';

function MoveProjectModal({
  onDismiss,
  visible,
  workspaces,
  handleMoveProject,
}) {
  const [filterValue, setFilterValue] = useState('');
  const [isMoveButtonDisabled, setMoveButtonDisabled] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);

  const selectWorkspaceListItem = (item) => () => {
    setSelectedItem(item);
    setMoveButtonDisabled(false);
  };

  const handleOnInput = (e) => {
    setFilterValue(e.target.value);
  };

  const handleClick = (workspaceId) => () => {
    handleMoveProject(workspaceId);
  };

  const filterList = (value) => {
    const currentWorkspaceId = workspaceService.getSelectedWorkspaceId();
    if (!workspaces) {
      return null;
    }

    if (!value) {
      return workspaces.filter((workspace) => (workspace.id !== currentWorkspaceId));
    }

    const searchValue = value.toLowerCase();

    return workspaces.filter((workspace) =>
      workspace.name.toLowerCase().indexOf(searchValue) >= 0 &&
      workspace.id !== currentWorkspaceId
    );
  };

  const filteredList = filterList(filterValue);

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      title={intl.formatMessage(messages.modalTitle)}
    >
      <ModalContent unpadBottom>
        <Input.Search
          width={'100%'}
          onChange={handleOnInput}
          placeholder={intl.formatMessage(messages.searchTextPlaceholder)}
          label={intl.formatMessage(messages.searchTextPlaceholder)}
        />
      </ModalContent>
      <WorkspaceList>
        {filteredList && filteredList.map((workspace) => (
          <WorkspaceListItem
            key={workspace.id}
            onClick={selectWorkspaceListItem(workspace)}
            selected={selectedItem && selectedItem.id === workspace.id}
          >
            <SVGIcon
              icon="duotoneProjects"
            />
            {workspace.name}
          </WorkspaceListItem>
        ))}
      </WorkspaceList>
      <ModalActions scrim>
        <Button grey onClick={onDismiss}>Cancel</Button>
        <Button
          primary
          onClick={handleClick(selectedItem ? selectedItem.id : null)}
          disabled={isMoveButtonDisabled}
        >
          {intl.formatMessage(messages.moveButtonText)}
        </Button>
      </ModalActions>
    </Modal>
  );
}

MoveProjectModal.propTypes = {
  onDismiss: PropTypes.func,
  visible: PropTypes.bool,
  workspaces: PropTypes.array,
  handleMoveProject: PropTypes.func,
};

const mapStateToProps = (state) => ({
  workspaces: selectWorkspacesList(state),
});

const mapDispatchToProps = (dispatch) => ({
  getProjectsList: () => dispatch(commandWorkspaceProjectList()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
  enhanceWithServices,
)(MoveProjectModal);
